(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ea-account-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-account-menu')) {
    customElements.define('ea-account-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.ea-account__panel');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        const form = this.querySelector('.ea-account__login-form');
        if (form) {
          const email = form.querySelector('[name="login_hint"]');
          const button = form.querySelector('[type="submit"]');
          const message = form.querySelector('.ea-account__login-status');
          const endpoint = 'https://ea-b2b-check.sociedadeyc.workers.dev/';
          let checkVersion = 0;
          let checkedEmail = '';
          let checkedStatus = '';

          const showMessage = (text, checking = false, disable = checking || text === form.dataset.pendingMessage || text === form.dataset.newMessage) => {
            message.textContent = text;
            message.hidden = false;
            message.classList.toggle('is-checking', checking);
            button.disabled = disable;
            button.setAttribute('aria-disabled', String(button.disabled));
            if (text === form.dataset.pendingMessage) email.setAttribute('aria-invalid', 'true');
            else email.removeAttribute('aria-invalid');
          };

          const clearMessage = () => {
            message.textContent = '';
            message.hidden = true;
            message.classList.remove('is-checking');
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            email.removeAttribute('aria-invalid');
          };

          const checkEmail = async (proceed) => {
            const value = email.value.trim().toLowerCase();
            if (!email.checkValidity()) return;
            if (checkedEmail === value && ['pending', 'new'].includes(checkedStatus)) {
              showMessage(checkedStatus === 'pending' ? form.dataset.pendingMessage : form.dataset.newMessage);
              return;
            }
            const version = ++checkVersion;
            showMessage(form.dataset.checkingMessage, true, proceed);
            try {
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: value })
              });
              if (!response.ok) throw new Error('HTTP ' + response.status);
              const data = await response.json();
              if (data?.ok !== true) throw new Error('Invalid validator response');
              const status = ['new', 'pending', 'approved'].includes(data.status)
                ? data.status
                : data.approved === true ? 'approved' : null;
              if (!status) throw new Error('Unknown account status');
              if (version !== checkVersion || email.value.trim().toLowerCase() !== value || !this.isConnected) return;
              checkedEmail = value;
              checkedStatus = status;
              if (status === 'pending' || status === 'new') {
                showMessage(status === 'pending' ? form.dataset.pendingMessage : form.dataset.newMessage);
                return;
              }
              clearMessage();
              if (proceed) {
                const url = new URL(form.dataset.loginUrl, window.location.origin);
                url.searchParams.set('login_hint', email.value.trim());
                window.location.assign(url.href);
              }
            } catch (error) {
              if (version !== checkVersion || !this.isConnected) return;
              checkedEmail = '';
              checkedStatus = '';
              console.warn('EA B2B login validator unavailable:', error);
              showMessage(form.dataset.errorMessage);
            }
          };

          clearMessage();
          email.addEventListener('input', () => {
            checkVersion += 1;
            checkedEmail = '';
            checkedStatus = '';
            clearMessage();
          }, options);
          email.addEventListener('blur', () => {
            if (email.value.trim() && email.checkValidity()) void checkEmail(false);
          }, options);
          form.addEventListener('submit', event => {
            event.preventDefault();
            if (!form.reportValidity()) return;
            void checkEmail(true);
          }, options);
        }

        this.position = () => {
          if (!this.details.open) return;
          const rect = this.summary.getBoundingClientRect();
          this.style.setProperty('--ea-account-top', Math.max(8, Math.min(rect.bottom + 8, window.innerHeight - 160)) + 'px');
          this.style.setProperty('--ea-account-right', Math.max(16, window.innerWidth - rect.right) + 'px');
        };

        this.close = (restoreFocus) => {
          this.details.open = false;
          if (restoreFocus) this.summary.focus();
        };

        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.details.open));
          this.position();
        }, options);

        this.querySelector('.ea-account__close').addEventListener('click', () => this.close(true), options);

        document.addEventListener('click', event => {
          if (this.details.open && !this.contains(event.target)) this.close(false);
        }, options);

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.close(true);
          }
        }, options);

        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
        }, options);

        window.addEventListener('resize', this.position, options);
        window.addEventListener('scroll', this.position, { ...options, capture: true, passive: true });
        this.summary.setAttribute('aria-expanded', 'false');
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
